import clsx from 'clsx';

interface FacebookStoryProps {
  className?: string;
}

const FacebookStory: React.FC<FacebookStoryProps> = ({ className }) => {
	return (
		<svg
			className={clsx('facebook-story', className)}
			fill="none"
			height="165"
			viewBox="0 0 100 165"
			width="100"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect fill="white" height="164" rx="7.5" width="99" x="0.5" y="0.5" />
			<rect height="164" rx="7.5" stroke="#D1D2D4" width="99" x="0.5" y="0.5" />
			<rect fill="#E3EFFF" height="149" width="84" x="8" y="8" />
			<path
				d="M59.9999 78.0728C59.9999 71.4046 54.627 65.999 47.9992 65.999C41.3714 65.999 35.9985 71.4046 35.9985 78.0728C35.9985 84.0992 40.387 89.0942 46.1241 90V81.5629H43.0771V78.0728H46.1241V75.4128C46.1241 72.3868 47.9158 70.7154 50.657 70.7154C51.9699 70.7154 53.3433 70.9512 53.3433 70.9512V73.9225H51.83C50.3393 73.9225 49.8743 74.8532 49.8743 75.808V78.0728H53.2027L52.6706 81.5629H49.8743V90C55.6115 89.0942 59.9999 84.0992 59.9999 78.0728Z"
				fill="#1977F2"
			/>
			<path d="M34 8H66C66 10.2091 64.2091 12 62 12H38C35.7909 12 34 10.2091 34 8Z" fill="white" />
			<rect fill="#EDEDEE" height="2" rx="1" width="10" x="43" y="8" />
			<rect fill="#EDEDEE" height="2" rx="1" width="2" x="55" y="8" />
		</svg>
	);
};


export default FacebookStory;
